import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Grid, Typography, TextField, Link } from '@mui/material';

import ProjectDetailInfo from '../../../components/projectmng/detail/ProjectDetailInfo';
import { viewEstimate } from '../../../modules/projectModule/projectEstimate';
import { setProject } from '../../../modules/projectModule/project';
import dayjs from 'dayjs';
import * as chanceApi from '../../../lib/api/chance';
import DetailTemplate from '../../../components/common/template/DetailTemplate';
import CostCalcLockContainer from '../costcalc/CostCalcLockContainer';
import AskDialog from '../../../components/common/dialog/AskDialog';
import ProjectDetailFormContainer from './ProjectDetailFormContainer';

const ProjectDetailInfoContainer = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { project, estimate } = useSelector(({ projectModule }) => ({
    project: projectModule.project.project,
    estimate: projectModule.projectEstimate.estimate,
  }));

  useEffect(() => {
    if (project) {
      // console.log(chance, "chance");
      dispatch(viewEstimate(project.prjUuid));
    }
  }, [dispatch, project]);

  //원가산출 확정/ 해제

  const [unLockVisible, setUnlockVisible] = useState(false);
  const onUnLockCancle = () => {
    setUnlockVisible(false);
  };
  const onUnLockConfirm = () => {
    setUnlockVisible(false);
    onCostUnLock();
  };
  const onCostUnLock = async () => {
    try {
      const res = await chanceApi.unDoCost(project.prjUuid);

      if (res.data.info) {
        dispatch(setProject(res.data.info));
        // dispatch(listProjectCosts(project.prjUuid));
        // dispatch(projectEstimateActive(project.prjUuid));
        // dispatch(projectOrderCount(project.prjUuid));

        navigate('/chancemng');

        enqueueSnackbar('원가산출이 해제되었습니다.', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          my: 2,
        }}
      >
        <Button
          variant="contained"
          color="warning"
          onClick={() => setUnlockVisible(true)}
        >
          원가산출 해제
        </Button>
      </Box> */}

      <DetailTemplate title="기본사항">
        {/* <ProjectDetailInfo project={project} /> */}
        <ProjectDetailFormContainer project={project} />
      </DetailTemplate>
      <Box sx={{ my: 2 }}>
        <CostCalcLockContainer project={project} />
      </Box>
      <DetailTemplate title="견적">
        {estimate ? (
          <>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  견적 번호
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {estimate?.qteNo}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  견적일자
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {estimate?.qteRegDt
                    ? estimate?.qteRegDt
                    : dayjs(estimate?.crtDt).format('YYYY-MM-DD')}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  견적 유효일자
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {estimate?.qteValidDt}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  담당자명
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {estimate.qteUsrNm}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  담당자 연락처
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {estimate?.qteUsrTel}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  담당자 이메일
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {estimate?.qteUsrEml}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  총 견적 금액
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  ₩{' '}
                  {estimate?.qtePrice
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  유지보수기간
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="body2" component="div">
                  {estimate?.mntTor} 개월
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  납품 장소
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2" component="div">
                  {estimate?.destPlace}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  발행 조건
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2" component="div">
                  {estimate?.qteCondt}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  결제 조건
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2" component="div">
                  {estimate?.payCond}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  견적서 설명 1
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2" component="div">
                  {estimate?.qteDesc1}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  견적서 설명 2
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2" component="div">
                  {estimate?.qteDesc2}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
            >
              <Grid item xs={2}>
                <Typography variant="subtitle2" component="div">
                  견적서 설명 3
                </Typography>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2" component="div">
                  {estimate?.qteDesc3}
                </Typography>
              </Grid>
            </Grid>
          </>
        ) : (
          <Box>
            <Typography variant="subtitle2" component="div">
              현재 활성화된 견적서가 없습니다.
            </Typography>
          </Box>
        )}
      </DetailTemplate>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          my: 2,
        }}
      >
        <Button
          variant="contained"
          color="warning"
          onClick={() => setUnlockVisible(true)}
        >
          원가산출 해제
        </Button>
      </Box>
      <AskDialog
        visible={unLockVisible}
        title="프로젝트 원가 산출 해제"
        description={`원가산출을 해제하시겠습니까?\r\n작업된(견적서 / 수주품의서 ) 등의 사항을 다시 작성해야됩니다.`}
        confirmText="해제"
        onConfirm={onUnLockConfirm}
        onCancle={onUnLockCancle}
      />
    </Box>
  );
};

export default ProjectDetailInfoContainer;
